import { createContext } from 'react';
import type { COOKIE_CATEGORIES } from './cookieCategories';
import type { CookieConsentPreferences, CookieConsentRecord } from './types';

export type CookieConsentContextValue = {
  consent: CookieConsentRecord | null;
  hasConsent: boolean;
  showBanner: boolean;
  showPreferences: boolean;
  categories: typeof COOKIE_CATEGORIES;
  acceptAll: () => void;
  acceptEssentialOnly: () => void;
  openPreferences: () => void;
  closePreferences: () => void;
  savePreferences: (prefs: Partial<CookieConsentPreferences>) => void;
  isCategoryEnabled: (category: keyof CookieConsentPreferences) => boolean;
};

export const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);
